<template>
    <footer class="mozzarella">
        <img :src="require(`../assets/logo/orange/${data.logo}`)" :alt="data.name" :title="data.name" />
    </footer>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

export default {
  name: "FooterSection",
  data: function() {
      return {
        data: Content[lang].navbar,
      }
  },
};
</script>

<style>
footer {
    text-align: center;
    padding: 45px 0;
}
footer img {
    max-width: 259px;
    margin: 0 auto;
}</style>